import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, ShoppingCart } from "lucide-react";
import { useBranding } from "../context/BrandingContext";

export default function PublicNavbar() {
  const navigate = useNavigate();
  const { branding } = useBranding();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  const hostname = window.location.hostname;
  const isSubdomain = hostname !== "localhost" && hostname !== "skillzy.pro" && !/^[0-9.]+$/.test(hostname);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
    
    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      setCartCount(cart.length);
    };

    updateCartCount();
    window.addEventListener("storage", updateCartCount);
    window.addEventListener("cartUpdated", updateCartCount);
    
    return () => {
      window.removeEventListener("storage", updateCartCount);
      window.removeEventListener("cartUpdated", updateCartCount);
    };
  }, []);

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Link to="/" className="flex items-center gap-3">
            {branding.logo && (
              <img src={branding.logo} alt="Logo" className="h-12 sm:h-14 w-auto max-w-[200px] object-contain shrink-0" />
            )}
            <span className="text-lg sm:text-xl font-black bg-gradient-to-r from-slate-900 to-indigo-950 bg-clip-text text-transparent uppercase tracking-wider">
              {branding.instituteName || "Antigravity"}
            </span>
          </Link>
          
          <div className="hidden lg:flex items-center gap-8 text-[14px] font-black text-slate-500 uppercase tracking-wider">
            <Link to="/public-exams" className="hover:text-indigo-600 transition-colors">Test Series</Link>
            <Link to="/public-courses" className="hover:text-indigo-600 transition-colors">Video Courses</Link>
            <Link to="/public-live-classes" className="hover:text-indigo-600 transition-colors">Live Classes</Link>
          </div>
        </div>

        <div className="flex items-center gap-6">
          <button
            onClick={() => navigate("/cart")}
            className="relative p-2 rounded-xl text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <ShoppingCart size={22} />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-indigo-600 text-[10px] font-black text-white shadow-lg">
                {cartCount}
              </span>
            )}
          </button>

          <div className="h-6 w-px bg-slate-200" />

          {isLoggedIn ? (
            <Link 
              to="/dashboard" 
              className="px-8 py-3 bg-indigo-600 text-white font-black rounded-2xl shadow-xl shadow-indigo-100 hover:bg-indigo-700 transition-all flex items-center gap-2"
            >
              Go to Dashboard <ArrowRight size={18} />
            </Link>
          ) : (
            <div className="flex items-center gap-4">
              {!isSubdomain && (
                <Link 
                  to="/register-institute" 
                  className="hidden sm:inline-flex px-5 py-2.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 font-black rounded-xl border border-indigo-100 transition-all text-[13px] uppercase tracking-wider items-center gap-1.5"
                >
                  Launch Your LMS
                </Link>
              )}
              <Link to="/login" className="px-6 py-2.5 text-indigo-600 font-black hover:text-indigo-700">Login</Link>
              <Link 
                to="/register" 
                className="px-8 py-3 bg-indigo-600 text-white font-black rounded-2xl shadow-xl shadow-indigo-100 hover:bg-indigo-700 transition-all"
              >
                Join Now
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

